import { render, staticRenderFns } from "./SupportTicketsList.vue?vue&type=template&id=156978e0"
import script from "./SupportTicketsList.vue?vue&type=script&lang=js"
export * from "./SupportTicketsList.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketsList.vue?vue&type=style&index=0&id=156978e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports